import PropTypes from 'prop-types';
import React from 'react';
import { useIntl } from 'react-intl';
import { makeStyles } from '@material-ui/core';
import RateCardIcon from '@material-ui/icons/AttachMoneySharp';
import {
  EditableCard2,
  Edit,
  EditContent,
  EditTitle,
  ReadOnly,
  ReadOnlyContent
} from '~/modules/common/components/EditableCard';
import {
  ProjectCostOverridesReadOnlyContent,
  ProjectCostOverridesDialogContent
} from './components';

const avatar = <RateCardIcon />;

const useCardStyles = makeStyles(theme => ({
  card: {
    marginTop: theme.spacing(2)
  }
}));

const noop = () => {};

export const ProjectCostOverrides = ({ editable = false }) => {
  const { formatMessage } = useIntl();
  const cardClasses = useCardStyles();

  return (
    <EditableCard2
      editable={editable}
      classes={cardClasses}
      ariaLabelKey="projectCostOverrides.cardTitle"
      dataQeId="ProjectCostOverridesCard"
    >
      <ReadOnly
        expandable={false}
        avatar={avatar}
        title={formatMessage({ id: 'projectCostOverrides.cardTitle' })}
      >
        <ReadOnlyContent>
          <ProjectCostOverridesReadOnlyContent />
        </ReadOnlyContent>
      </ReadOnly>
      <Edit onSave={noop} onCancel={noop}>
        <EditTitle>
          {formatMessage({ id: 'projectCostOverrides.cardTitle' })}
        </EditTitle>
        <EditContent>
          <ProjectCostOverridesDialogContent />
        </EditContent>
      </Edit>
    </EditableCard2>
  );
};

ProjectCostOverrides.propTypes = {
  editable: PropTypes.bool
};

export default ProjectCostOverrides;
